import { useAtom } from '@reatom/npm-react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { TradeSettings } from '@root/entities/trade-settings'
import { tradeSettingsAtom } from '@root/features/trade/trade-settings'
import { AntiMevShield } from '@root/features/trade/trade-settings/ui/desktop'

import { InstantTradeSwapGas } from '../instant-trade-swap'

import type { ClassNameProps } from '@root/shared/react'

type InstantTradeBottomGasProps = {
  swapDirection: 'buy' | 'sell'
} & ClassNameProps

export const InstantTradeBottomGas: React.FC<InstantTradeBottomGasProps> = ({
  className,
}) => {
  const { t } = useTranslation()
  const [settings] = useAtom(tradeSettingsAtom)
  const isMevProtectionEnabled = TradeSettings.isAntiMevEnabled(settings)

  return (
    <Root className={className}>
      <GasSettings iconsSize={12} withMevProtection={false} swapType="buy" />
      {isMevProtectionEnabled === undefined ? (
        <div />
      ) : (
        <Mev>
          <AntiMevShield active={isMevProtectionEnabled} size={12} />
          {t('trade_settings.anti_mev.info-title')}
        </Mev>
      )}
    </Root>
  )
}

const Root = styled.div`
  padding-inline: 8px 0;
  display: grid;
  grid-auto-flow: row;
  justify-items: start;
  align-content: center;
  gap: 5px;
`

const Mev = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 2px;
  white-space: nowrap;
  color: var(--text-12);

  font-size: 10px;
  font-weight: 500;
  line-height: 12px;
`

const GasSettings = styled(InstantTradeSwapGas)`
  && {
    margin: 0;
    --instant-trade-swap-gas-gap: 5px;
    --instant-trade-swap-gas-font-size: 10px;
    --instant-trade-swap-gas-separator-height: 14px;
  }
`
